import { Card, ContactForm, MainDiv } from "../component";

import { faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";

import "../asset/style/Contact.css";

function Contact(){
    let contact_info = [
      {
        header: "Address",
        content: process.env.REACT_APP_ADDRESS,
        icon: faLocationDot
      },
      {
        header: "Call me",
        content: process.env.REACT_APP_PHONE,
        icon: faPhone
      },
      {
        header: "Email",
        content: process.env.REACT_APP_EMAIL,
        icon: faEnvelope
      },
    ];

    contact_info= contact_info.map((item)=>{
        return (<Card key={item.header} header={item.header} content={item.content} icon={item.icon} />);
    });

    return (
      <MainDiv>
        <h1>Contact</h1>
        <p>
          Get in touch with me for collaborations, opportunities, or enquiries.
        </p>
        <div className="contact_card">
          <div className="contact_info">
            { contact_info }
          </div>
          <ContactForm />
        </div>
      </MainDiv>
    );
}

export default Contact;